"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFavorite = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconFavorite = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M23.731 10.068c.527-.54.235-1.483-.491-1.593l-6.756-1.03a.885.885 0 01-.667-.514L12.797.524a.876.876 0 00-1.605 0L8.183 6.93a.935.935 0 01-.667.515L.76 8.476c-.726.11-1.018 1.053-.491 1.592l4.882 4.986c.21.22.304.527.257.821l-1.147 7.032c-.129.76.644 1.348 1.3.98l6.04-3.32a.838.838 0 01.832 0l6.042 3.32c.655.356 1.416-.22 1.3-.98l-1.16-7.032a.948.948 0 01.258-.82l4.858-4.987z"
}));
exports.IconFavorite = IconFavorite;
//# sourceMappingURL=IconFavorite.js.map